import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Fab, Zoom } from '@mui/material';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const SCROLL_THRESHOLD = 300;

const ScrollToTopButton: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const containerRef = useRef<Element | null>(null);

  useEffect(() => {
    const container = document.querySelector('[data-scroll-container]');
    containerRef.current = container;
    if (!container) return;

    const handleScroll = () => {
      setVisible(container.scrollTop > SCROLL_THRESHOLD);
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = useCallback(() => {
    containerRef.current?.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <Zoom in={visible}>
      <Fab
        size="medium"
        aria-label="scroll to top"
        onClick={scrollToTop}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          zIndex: 40,
          bgcolor: 'primary.main',
          color: 'white',
          boxShadow: '0 4px 14px rgba(0, 0, 0, 0.15)',
          '&:hover': {
            bgcolor: 'primary.dark',
            boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',
          },
        }}
      >
        <KeyboardArrowUpIcon />
      </Fab>
    </Zoom>
  );
};

export default ScrollToTopButton;
